import { ArrowUpRight, Check } from "lucide-react";
import { useLanguage } from "@/i18n";
import { waLink } from "@/whatsapp";
import { Reveal, SectionHeader } from "@/components/Reveal";

export const PackagesSection = () => {
  const { t } = useLanguage();

  return (
    <section id="forfaits" className="py-24 sm:py-32 bg-obsidian" data-testid="packages-section">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <SectionHeader eyebrow={t.packages.eyebrow} title={t.packages.title} sub={t.packages.sub} />

        <div className="mt-16 grid md:grid-cols-2 xl:grid-cols-4 gap-5">
          {t.packages.items.map((pkg, i) => (
            <Reveal key={pkg.id} delay={0.08 * i} className="h-full">
              <div
                data-testid={`package-card-${pkg.id}`}
                className={`relative h-full flex flex-col rounded-lg p-7 sm:p-8 transition-colors duration-500 ${
                  pkg.popular
                    ? "bg-surface border border-gold/50 shadow-[0_0_35px_rgba(212,175,55,0.12)]"
                    : "bg-midnight border border-hairline hover:border-gold/30"
                }`}
              >
                {pkg.popular && (
                  <span className="absolute -top-3 left-7 bg-gold text-obsidian font-mono text-[9px] uppercase tracking-[0.2em] px-3 py-1 rounded-full">
                    {t.packages.popular}
                  </span>
                )}
                <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-gold">{pkg.tag}</p>
                <h3 className="mt-3 font-serif text-3xl font-semibold text-ivory">{pkg.name}</h3>
                <p className="mt-1 text-sm text-slate-400">{pkg.headline}</p>

                <ul className="mt-6 space-y-3 flex-1">
                  {pkg.features.map((f, j) => (
                    <li key={j} className="flex gap-3 text-[13px] leading-relaxed text-slate-300">
                      <Check className="w-4 h-4 mt-0.5 shrink-0 text-gold" strokeWidth={2} />
                      {f}
                    </li>
                  ))}
                </ul>

                <p className="mt-6 text-xs italic text-slate-500">
                  {t.packages.bestFor} : {pkg.bestFor}
                </p>

                <div className="mt-5 inline-flex items-center self-start border border-gold/40 text-gold font-mono text-[10px] uppercase tracking-[0.2em] px-3 py-1.5 rounded-full">
                  {t.packages.priceLabel}
                </div>

                <a
                  href={waLink(t.wa.msgQuote(pkg.name))}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid={`package-quote-cta-${pkg.id}`}
                  className={`mt-6 group inline-flex items-center justify-center gap-2 rounded-full py-3 text-sm font-semibold tracking-wide transition-colors duration-300 ${
                    pkg.popular
                      ? "bg-gold text-obsidian hover:bg-gold-light"
                      : "border border-ivory/25 text-ivory hover:border-gold hover:text-gold"
                  }`}
                >
                  {t.packages.cta}
                  <ArrowUpRight className="w-4 h-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                </a>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
